<template>

<com-setting :options="options" :value="value" v-on:change="onChange" />

</template>

<script>

import comSetting from './Setting'

export default {

    props: ['type', 'value'],

    components: {
        'com-setting': comSetting
    },

    data: function() {

        return {
            name: {
                all: 'All-time',
                specific: 'Specific period',
                day: 'Day',
                week: 'Week',
                month: 'Month',
                year: 'Year'
            },
            numeric: {},
            date: {}
        }

    },

    computed: {

        options: function() {

            var options = []

            this.$_.each(this.type.setting.period, function(logic) {

                options.push({
                    value: logic,
                    text: this[this.type.type][logic] || this.name[logic]
                })

            }.bind(this))

            return options

        }

    },

    methods: {

        onChange: function(value) {

            this.$emit('input', value)

        }
    
    }

}

</script>

<style scoped>

</style>